import React, { useState } from 'react';

export default function EmailCapture({ label = "Get your free Hormone Symptom Checklist", dark = false }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');

    try {
      const res = await fetch('/.netlify/functions/send-checklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="email-capture">
        <p className="email-capture__success">Checklist on its way — check your inbox.</p>
      </div>
    );
  }

  return (
    <div className="email-capture" style={dark ? { background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' } : {}}>
      <p className="email-capture__label" style={dark ? { color: 'rgba(255,255,255,0.6)' } : {}}>{label}</p>
      <form onSubmit={handleSubmit}>
        <div className="email-capture__row">
          <input
            className="email-capture__input"
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <button className="email-capture__btn" type="submit" disabled={status === 'loading'}>
            {status === 'loading' ? 'Sending...' : 'Send it free'}
          </button>
        </div>
        {status === 'error' && (
          <p className="email-capture__note" style={{ color: '#c0392b' }}>Something went wrong — please try again.</p>
        )}
        <p className="email-capture__note" style={dark ? { color: 'rgba(255,255,255,0.35)' } : {}}>No spam. Unsubscribe any time.</p>
      </form>
    </div>
  );
}
